import { Button } from '@talentmesh/ui/components/button';
import UIStrings from '@/Utils/UIStrings';

interface ClearAllButtonProps {
    onClearAll: () => void;
}

const ClearAllButton = ({ onClearAll }: ClearAllButtonProps) => {
    return (
        <Button
            size="sm"
            variant="ghost"
            onClick={(e) => {
                e.preventDefault();
                onClearAll();
            }}
        >
            {UIStrings.ClearAll}
        </Button>
    );
};

export default ClearAllButton;
